import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import type { CmsApiCategoryHighlightBlockData } from '#/modules/cms/api/types/blocks/CmsApiCategoryHighlightBlock';
import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

import {
  CmsCategoryHighlightBlock_Box_1,
  CmsCategoryHighlightBlock_Box_2,
} from './CmsCategoryHighlightBlock.styled';
import { CmsCategoryHighlightBlockCategory } from './CmsCategoryHighlightBlockCategory';

type Props = {
  content: CmsApiDocument;
  data: CmsApiCategoryHighlightBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsCategoryHighlightBlock({
  content,
  data: { headline, categories },
  blockIndex,
  pageUpdated,
}: Props) {
  const homePageUrl = content.subsite.homePage?.url;

  return (
    <div data-qa-id="cms-category-highlight">
      {headline && (
        <CmsCategoryHighlightBlock_Box_2>
          <RichTextHeadline>{headline}</RichTextHeadline>
        </CmsCategoryHighlightBlock_Box_2>
      )}

      <CmsCategoryHighlightBlock_Box_1>
        {categories.map((category, index) => (
          <CmsCategoryHighlightBlockCategory
            category={category}
            homePageUrl={homePageUrl}
            key={`${category.name}-${index}`}
            blockIndex={blockIndex}
            pageUpdated={pageUpdated}
          />
        ))}
      </CmsCategoryHighlightBlock_Box_1>
    </div>
  );
}
